import { useEffect } from 'react';

import {
  AboutStudio,
  Contacts,
  Documents,
  Faq,
  Feedbacks,
  MainPage,
  Gallery,
  Groups,
  Prices,
  Stats,
  Teachers,
  WhyUs,
} from './components/components';
import { NavBar } from './components/main-page/components/nav-bar/nav-bar';
import { Footer } from './components/main-page/components/footer/footer';
import { FloatingCta } from './components/main-page/components/floating-cta/floating-cta';

export const App = () => {
  const isDocumentsPage = window.location.pathname.replace(/\/$/, '') === '/documents';

  useEffect(() => {
    document.title = isDocumentsPage
      ? 'Документи — Хореографічна студія «Мрія» у Києві'
      : 'Хореографічна студія «Мрія» у Києві — дитяча хореографія та бальні танці';
  }, [isDocumentsPage]);

  useEffect(() => {
    if (isDocumentsPage || !('IntersectionObserver' in window)) {
      return undefined;
    }

    const sections = document.querySelectorAll('.main-style:not(.main-page)');
    sections.forEach((el) => el.classList.add('reveal'));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    sections.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [isDocumentsPage]);

  return (
    <div className="app-shell">
      <a href={isDocumentsPage ? '#documents' : '#home'} className="skip-link">
        Перейти до основного контенту
      </a>
      <NavBar />
      <main className="app-main">
        {isDocumentsPage ? (
          <Documents />
        ) : (
          <>
            <MainPage />
            <Stats />
            <AboutStudio />
            <WhyUs />
            <Teachers />
            <Groups />
            <Gallery />
            <Feedbacks />
            <Prices />
            <Faq />
            <Contacts />
          </>
        )}
      </main>
      <Footer />
      {!isDocumentsPage && <FloatingCta />}
    </div>
  );
};
